module.exports = __webpack_public_path__ + "static/media/car-delivery.6248acbf.svg";